import React, { PureComponent } from 'react';

import FaqsMeta from './meta';
import Faqs from './component';

const TRACKING_PREFIX = 'faqs';

class FaqsContainer extends PureComponent {
  static shouldShowFaqs = (faqs) => faqs && faqs.length;

  render() {
    const {
      eventId,
      faqs,
      titleClass,
      questionClass,
      answerClass,
      hideAskQuestion,
    } = this.props;

    if (!faqs || !faqs.length) return null;

    const componentProps = {
      eventId,
      titleClass,
      questionClass,
      answerClass,
      faqs,
      hideAskQuestion,
      trackingPrefix: TRACKING_PREFIX,
    };

    return (
      <>
        <FaqsMeta faqs={faqs} />
        <Faqs {...componentProps} />
      </>
    );
  }
}

export default FaqsContainer;
